<template>
    <div
        class="survey__row__container__row__cell"
        @click="$emit('input', radioValue)">
        <div v-if="response !== null">
            <label class="d-block mb-1" :class="{ 'text-muted': disabled }">{{ response }}</label>
            <b-form-radio
                ref="input"
                :value="radioValue"
                :name="radioName"
                @change="$emit('input', radioValue)"
                :disabled="disabled"
                :checked="value == radioValue"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'survey-response',
    props: {
        response: String,
        value: [ String, Number ],
        radioName: String,
        radioValue: [ String, Number ],
        disabled: Boolean
    },
    watch: {
        value(value) {
            if (this.$refs.input === undefined) return
            this.$nextTick(() => this.$refs.input._data.localChecked = value)
        }
    }
}
</script>
